import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  AllAttendanceRequest,
  AttendanceOutRequestType,
  GetEmployeeStatusResponse,
  GetEmployeesAttendanceResponse,
  GetemployeeActivityResponse,
  GetRegularizeRequest,
  GetRegularizeResponse,
  PutRegularizeRequestStatus,
  MarkInAttendanceBodyProps,
  SingleAttendenceRespnse,
} from './types';
import { AUTH_URL } from '../../util/constants';

export const attendanceApi = createApi({
  reducerPath: 'attendanceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: AUTH_URL,
  }),
  tagTypes: [
    'queryAllusersAttendance',
    'mutateRole',
    'userAttendanceById',
    'getCurrentUser',
    'allUsersById',
    'userEmployeeAactivityById',
    'userEmployeeStatus',
    'GetRegularizeRequest',
    'monthlyAttendance',
    'PutRegularizeRequestStatus',
  ],
  endpoints: (builder) => ({
    clockInAttendance: builder.mutation<any, MarkInAttendanceBodyProps>({
      query: (attendance) => ({
        url: `/clockInAttendance`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: attendance,
        credentials: 'include',
      }),
      invalidatesTags: ['getCurrentUser'],
    }),

    clockOutAttendance: builder.mutation<any, AttendanceOutRequestType>({
      query: (attendance) => ({
        url: `/clockOutAttendance`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: attendance,
        credentials: 'include',
      }),
      invalidatesTags: ['getCurrentUser'],
    }),

    getEmployeesAttendance: builder.query<
      GetEmployeesAttendanceResponse,
      AllAttendanceRequest
    >({
      query: (args) => ({
        url: '/getEmployeesAttendance',
        credentials: 'include',
        params: args,
      }),
      providesTags: ['queryAllusersAttendance'],
    }),

    getEmployeeAttendance: builder.query<
      SingleAttendenceRespnse,
      {
        _id: string;
        timeZone: string;
        page?: number | undefined;
        limit?: number | undefined;
      }
    >({
      query: ({ _id, ...args }) => ({
        url: `/getEmployeeAttendance/${_id}`,
        method: 'GET',
        params: args,
        credentials: 'include',
      }),
      providesTags: ['userAttendanceById'],
    }),
    getEmployeeAactivity: builder.query<
      any,
      {
        employeeId?: string;
        startDate: string;
        endDate: string;
        limit: number;
        page: number;
      }
    >({
      query: ({ employeeId, startDate, endDate, limit = 10, page = 1 }) => ({
        url: `/getemployeeactivity/${employeeId}`,
        method: 'GET',
        params: {
          startDate,
          endDate,
          limit,
          page,
        },
        credentials: 'include',
      }),
      providesTags: ['userEmployeeAactivityById'],
    }),
    getSalaryReport: builder.query<any, { startDate: string; endDate: string }>({
      query: ({ startDate, endDate }) => ({
        url: `/report/salary`,
        method: 'GET',
        params: { startDate, endDate },
        credentials: 'include',
      }),

      providesTags: ['monthlyAttendance'],
    }),
    getEmployeeReport: builder.query<any, { startDate: string; endDate: string }>({
      query: ({ startDate, endDate }) => ({
        url: `/report/employee`,
        method: 'GET',
        params: { startDate, endDate },
        credentials: 'include',
      }),

      providesTags: ['monthlyAttendance'],
    }),
    getuserStatus: builder.query<GetEmployeeStatusResponse, {}>({
      query: () => ({
        url: `/getuserStatus`,
        method: 'GET',
        credentials: 'include',
      }),
      providesTags: ['userEmployeeStatus'],
    }),
    getRegularizeRequests: builder.query<
      GetRegularizeResponse,
      GetRegularizeRequest
    >({
      query: (args) => ({
        url: `/regularise`,
        method: 'GET',
        params: args,
        credentials: 'include',
      }),
      providesTags: ['GetRegularizeRequest'],
    }),
    putRegularizeRequestsStatus: builder.mutation<
      any,
      PutRegularizeRequestStatus
    >({
      query: (data) => ({
        url: '/regularise',
        method: 'PUT',
        body: data,
        credentials: 'include',
      }),
      invalidatesTags: ['PutRegularizeRequestStatus'],
    }),
    takeScreenShot: builder.mutation<
      GetemployeeActivityResponse,
      {
        attendanceId?: string;
      }
    >({
      query: (args) => ({
        url: `/data`,
        method: 'GET',
        params: args,
        credentials: 'include',
      }),
    }),
    getMonthlyAttendances: builder.query<
      any,
      { startDate: string; endDate: string }
    >({
      query: ({ startDate, endDate }) => ({
        url: `/getCurrentMonth`,
        method: 'GET',
        params: { startDate, endDate },
        credentials: 'include',
      }),
      providesTags: ['monthlyAttendance'],
    }),
    getEmployeeMonthly: builder.query<
      any,
      { employeeId: string; startDate: string; endDate: string }
    >({
      query: ({ employeeId, startDate, endDate }) => ({
        url: `/getEmployeeMonthly/${employeeId}`,
        method: 'GET',
        params: { startDate, endDate },
        credentials: 'include',
      }),
      providesTags: (result, error, { employeeId }) =>
        result ? [{ type: 'monthlyAttendance', id: employeeId }] : [],
    }),
    getChatBot: builder.mutation<any, any>({
      query: (userData) => ({
        url: `/ai/chatbot`,
        method: 'POST',
        body: userData,
        credentials: 'include',
      }),
    }),
  }),
});
export const {
  useClockInAttendanceMutation,
  useClockOutAttendanceMutation,
  useGetEmployeeAttendanceQuery,
  useLazyGetEmployeesAttendanceQuery,
  useLazyGetEmployeeAactivityQuery,
  useGetuserStatusQuery,
  useLazyGetMonthlyAttendancesQuery,
  useTakeScreenShotMutation,
  useGetRegularizeRequestsQuery,
  useLazyGetEmployeeMonthlyQuery,
  usePutRegularizeRequestsStatusMutation,
  useLazyGetEmployeeReportQuery,
  useLazyGetSalaryReportQuery,
  useGetChatBotMutation,
} = attendanceApi;
